import React from "react";

import 'dayjs/locale/it';
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localizedFormat from "dayjs/plugin/localizedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekday from 'dayjs/plugin/weekday';
import {TABS_CHOOSEN} from "./costanti";


dayjs.locale('it');
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(localizedFormat);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
dayjs.extend(isoWeek);
dayjs.extend(weekday)

export const dayJS = dayjs;

const Tipizzazione = React.lazy(() => import('./views/SuperAdmin/Tipizzazione/TipizzazioneContainer'));
const ModificaAllievi = React.lazy(() => import('./views/SuperAdmin/RicercaCorso/ModificaAllievi/ModificaAllieviPage'));
const RicercaCorso = React.lazy(() => import('./views/SuperAdmin/RicercaCorso/RicercaCorso'));
const TimbratureEliminate = React.lazy(() => import('./views/SuperAdmin/TimbratureEliminate/TimbratureEliminateContainer'));
const DbEditor = React.lazy(() => import('./views/SuperAdmin/DbEditor/DbEditorContainer'));

export const DB_EDITOR_UTENTI_ABILITATI = Object.freeze([
    'DCRLRD04P10L103P',
    'GRNDNT87A03L738W',
    'RJSVYN00A54Z611O',
    'BRTPTR98P13E379A',
    'MNGLRT70M02F839Q',
    'SZCMLS75R67L049K',
    'CLLNGL69L69G999P',
    'MROCHR83B57D583B',
    'CLLRNI71S69G999X'
]);

export const RUOLI = Object.freeze({
    SYSTEMADMIN: {
        RUOLO: 'SystemAdmin',
        BUTTON: [{
            TIPO: ['A', 'C', 'D'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioFSE', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/pianificazione/inserisci', DISPLAY_VALUE: 'Pianificazione'},
                {LINK: '/profilazioneFSE', DISPLAY_VALUE: 'Profilazione'},
                {LINK: '/profiliorariFSE', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/castelletto', DISPLAY_VALUE: 'Castelletto', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {LINK: '/validazionecorso', DISPLAY_VALUE: 'Validazione'},
                {LINK: '/monitoraggioValidazione', DISPLAY_VALUE: 'Monitoraggio Validazione'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }, {
            TIPO: ['B'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro Mese',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioSCR', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/profiliorariSCR', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }
        ],
        HEADER: [
            {LINK: '', DISPLAY_VALUE: 'Home'},
            {LINK: '/corsi', DISPLAY_VALUE: 'Corsi'},
            {LINK: '/inserimentoAnagrafica', DISPLAY_VALUE: 'Inserimento Anagrafica'}
        ],
        SUPER_ADMIN: {
            LINKS: [
                {LINK: '/tipizzazione', DISPLAY_VALUE: 'Tipizzazione', LAZY_COMPONENT: Tipizzazione},
                {LINK: '/ricercacorso', DISPLAY_VALUE: 'Ricerca Corso', LAZY_COMPONENT: RicercaCorso},
                {LINK: '/timbratureEliminate', DISPLAY_VALUE: 'Timbrature Eliminate', LAZY_COMPONENT: TimbratureEliminate},
                {LINK: '/databaseEditor', DISPLAY_VALUE: 'Editor Database', LAZY_COMPONENT: DbEditor, RESTRICTED_TO_CF: DB_EDITOR_UTENTI_ABILITATI}
            ],
            CONTEXT_ROUTES: '/superAdmin',
            ROUTES: [
                {LINK: '/ricercacorso/modificaAllievo/corso/:id', LAZY_COMPONENT: ModificaAllievi}
            ]
        },
        TABS: {
            PRESENZE : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            REGISTRO : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            CASTELLETTO : {
                A: ['allievi', 'docenti', 'corso'],
                B: ['allievi', 'tutor', 'corso'],
                C: ['allievi', 'docenti','corso'],
                D: ['allievi', 'docenti','corso']
            }
        },
        EXTEND_COUSES_SEARCH: true,
        ACTION_DETTAGLIO: true,
        ACTION_MULTIPLE_SELECTED_REGISTRY: true,
        ACTION_MULTIPLE_DEVALIDATION_REGISTRY: true,
        STAMPA_PDF: true,
        DELETE_TIMBRATURE_MANUALI: true,
        DELETE_GIUSTIFICATIVI: true,
        DELETE_TIMBRATURE_AUTOMATICHE: true
    },
    ADMIN: {
        RUOLO: 'Admin',
        SUPER_ADMIN: {
            LINKS: [
                {LINK: '/timbratureEliminate', DISPLAY_VALUE: 'Timbrature Eliminate', LAZY_COMPONENT: TimbratureEliminate},
                {LINK: '/databaseEditor', DISPLAY_VALUE: 'Editor Database', LAZY_COMPONENT: DbEditor, RESTRICTED_TO_CF: DB_EDITOR_UTENTI_ABILITATI}
            ],
            CONTEXT_ROUTES: '/superAdmin',
            ROUTES: []
        },
        BUTTON: [{
            TIPO: ['A', 'C', 'D'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioFSE', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/pianificazione/inserisci', DISPLAY_VALUE: 'Pianificazione'},
                {LINK: '/profilazioneFSE', DISPLAY_VALUE: 'Profilazione'},
                {LINK: '/profiliorariFSE', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/castelletto', DISPLAY_VALUE: 'Castelletto', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {LINK: '/validazionecorso', DISPLAY_VALUE: 'Validazione'},
                {LINK: '/monitoraggioValidazione', DISPLAY_VALUE: 'Monitoraggio Validazione'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }, {
            TIPO: ['B'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro Mese',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioSCR', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/profiliorariSCR', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }
        ],
        HEADER: [
            {LINK: '', DISPLAY_VALUE: 'Home'},
            {LINK: '/corsi', DISPLAY_VALUE: 'Corsi'},
            {LINK: '/inserimentoAnagrafica', DISPLAY_VALUE: 'Inserimento Anagrafica'}
        ],
        TABS: {
            PRESENZE : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            REGISTRO : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            CASTELLETTO : {
                A: ['allievi', 'docenti', 'corso'],
                B: ['allievi', 'tutor', 'corso'],
                C: ['allievi', 'docenti','corso'],
                D: ['allievi', 'docenti','corso']
            }
        },
        EXTEND_COUSES_SEARCH: true,
        ACTION_DETTAGLIO: true,
        ACTION_MULTIPLE_SELECTED_REGISTRY: true,
        ACTION_MULTIPLE_DEVALIDATION_REGISTRY: true,
        STAMPA_PDF: true,
        DELETE_TIMBRATURE_MANUALI: true,
        DELETE_GIUSTIFICATIVI: true,
        DELETE_TIMBRATURE_AUTOMATICHE: true
    },
    DOCENTE: {
        RUOLO: 'Docente',
        BUTTON: [
            {
                TIPO: ['A', 'C', 'D'],
                CAMPI: [
                    {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                    {LINK: '/calendarioFSE', DISPLAY_VALUE: 'Calendario'},
                    {
                        LINK: '/registro',
                        DISPLAY_VALUE: 'Registro',
                        SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                    },
                    {LINK: '/castelletto', DISPLAY_VALUE: 'Castelletto', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}}
                ]
            }, {
                TIPO: ['B'],
                CAMPI: [
                    {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                    {
                        LINK: '/registro',
                        DISPLAY_VALUE: 'Registro Mese',
                        SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                    },
                    {LINK: '/calendarioSCR', DISPLAY_VALUE: 'Calendario'}
                ]
            }],
        HEADER: [
            {LINK: '', DISPLAY_VALUE: 'Home'},
            {LINK: '/corsi', DISPLAY_VALUE: 'Corsi'}
        ],
        TABS: {
            PRESENZE : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            REGISTRO : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            CASTELLETTO : {
                A: ['allievi', 'docenti', 'corso'],
                B: ['allievi', 'tutor', 'corso'],
                C: ['allievi', 'docenti','corso'],
                D: ['allievi', 'docenti','corso']
            }
        },
        EXTEND_COUSES_SEARCH: false,
        ACTION_DETTAGLIO: true,
        ACTION_MULTIPLE_SELECTED_REGISTRY: false,
        STAMPA_PDF: true,
        DELETE_TIMBRATURE_MANUALI: true,
        DELETE_GIUSTIFICATIVI: false,
        DELETE_TIMBRATURE_AUTOMATICHE: false
    },
    ALLIEVO: {
        RUOLO: 'Allievo',
        BUTTON: [
            {
                TIPO: ['A', 'C', 'D'],
                CAMPI: [
                    {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                    {LINK: '/castelletto', DISPLAY_VALUE: 'Castelletto', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}}
                ]
            }, {
                TIPO: ['B'],
                CAMPI: [{LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}}]
            }],
        HEADER: [
            {LINK: '', DISPLAY_VALUE: 'Home'},
            {LINK: '/corsi', DISPLAY_VALUE: 'Corsi'}
        ],
        TABS: {
            PRESENZE : {
                A: ['allievi'],
                B: ['allievi'],
                C: ['allievi'],
                D: ['allievi']
            },
            REGISTRO : {
                A: ['allievi'],
                B: ['allievi'],
                C: ['allievi'],
                D: ['allievi']
            },
            CASTELLETTO : {
                A: ['allievi'],
                B: ['allievi'],
                C: ['allievi'],
                D: ['allievi']
            }
        },
        EXTEND_COUSES_SEARCH: false,
        ACTION_DETTAGLIO: false,
        ACTION_MULTIPLE_SELECTED_REGISTRY: false,
        DELETE_TIMBRATURE_MANUALI: false,
        DELETE_GIUSTIFICATIVI: false,
        DELETE_TIMBRATURE_AUTOMATICHE: false
    },
    ENTE: {
        RUOLO: 'Ente',
        BUTTON: [{
            TIPO: ['A', 'C', 'D'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioFSE', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/pianificazione/inserisci', DISPLAY_VALUE: 'Pianificazione'},
                {LINK: '/profilazioneFSE', DISPLAY_VALUE: 'Profilazione'},
                {LINK: '/profiliorariFSE', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/castelletto', DISPLAY_VALUE: 'Castelletto', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {LINK: '/validazionecorso', DISPLAY_VALUE: 'Validazione'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }, {
            TIPO: ['B'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro Mese',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioSCR', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/profiliorariSCR', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }
        ],
        HEADER: [
            {LINK: '', DISPLAY_VALUE: 'Home'},
            {LINK: '/corsi', DISPLAY_VALUE: 'Corsi'}
        ],
        TABS: {
            PRESENZE : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            REGISTRO : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            CASTELLETTO : {
                A: ['allievi', 'docenti', 'corso'],
                B: ['allievi', 'tutor', 'corso'],
                C: ['allievi', 'docenti','corso'],
                D: ['allievi', 'docenti','corso']
            }
        },
        EXTEND_COUSES_SEARCH: false,
        ACTION_DETTAGLIO: true,
        ACTION_MULTIPLE_SELECTED_REGISTRY: true,
        ACTION_MULTIPLE_DEVALIDATION_REGISTRY: false,
        STAMPA_PDF: true,
        DELETE_TIMBRATURE_MANUALI: true,
        DELETE_GIUSTIFICATIVI: true,
        DELETE_TIMBRATURE_AUTOMATICHE: false
    },
    UTENTEREGIONE: {
        RUOLO: 'Utente Regione',
        BUTTON: [{
            TIPO: ['A', 'C', 'D'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioFSE', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/pianificazione/inserisci', DISPLAY_VALUE: 'Pianificazione'},
                {LINK: '/profiliorariFSE', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/castelletto', DISPLAY_VALUE: 'Castelletto', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {LINK: '/validazionecorso', DISPLAY_VALUE: 'Validazione'},
                {LINK: '/monitoraggioValidazione', DISPLAY_VALUE: 'Monitoraggio Validazione'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }, {
            TIPO: ['B'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro Mese',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioSCR', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/profiliorariSCR', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }
        ],
        HEADER: [
            {LINK: '', DISPLAY_VALUE: 'Home'},
            {LINK: '/corsi', DISPLAY_VALUE: 'Corsi'},
            {LINK: '/inserimentoAnagrafica', DISPLAY_VALUE: 'Inserimento Anagrafica'}
        ],
        TABS: {
            PRESENZE : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            REGISTRO : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            CASTELLETTO : {
                A: ['allievi', 'docenti', 'corso'],
                B: ['allievi', 'tutor', 'corso'],
                C: ['allievi', 'docenti','corso'],
                D: ['allievi', 'docenti','corso']
            }
        },
        EXTEND_COUSES_SEARCH: true,
        ACTION_DETTAGLIO: true,
        ACTION_MULTIPLE_SELECTED_REGISTRY: true,
        STAMPA_PDF: true,
        DELETE_TIMBRATURE_MANUALI: true,
        DELETE_GIUSTIFICATIVI: true,
        DELETE_TIMBRATURE_AUTOMATICHE: false
    },
    UTR: {
        RUOLO: 'Utente UTR',
        BUTTON: [{
            TIPO: ['A', 'C', 'D'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioFSE', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/pianificazione/inserisci', DISPLAY_VALUE: 'Pianificazione'},
                {LINK: '/profiliorariFSE', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/castelletto', DISPLAY_VALUE: 'Castelletto', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {LINK: '/validazionecorso', DISPLAY_VALUE: 'Validazione'},
                {LINK: '/monitoraggioValidazione', DISPLAY_VALUE: 'Monitoraggio Validazione'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }, {
            TIPO: ['B'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro Mese',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioSCR', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/profiliorariSCR', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }
        ],
        HEADER: [
            {LINK: '', DISPLAY_VALUE: 'Home'},
            {LINK: '/corsi', DISPLAY_VALUE: 'Corsi'}
        ],
        TABS: {
            PRESENZE : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            REGISTRO : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            CASTELLETTO : {
                A: ['allievi', 'docenti', 'corso'],
                B: ['allievi', 'tutor', 'corso'],
                C: ['allievi', 'docenti','corso'],
                D: ['allievi', 'docenti','corso']
            }
        },
        EXTEND_COUSES_SEARCH: true,
        ACTION_DETTAGLIO: true,
        ACTION_MULTIPLE_SELECTED_REGISTRY: true,
        STAMPA_PDF: true,
        DELETE_TIMBRATURE_MANUALI: true,
        DELETE_GIUSTIFICATIVI: true,
        DELETE_TIMBRATURE_AUTOMATICHE: false
    },
    RDA: {
        RUOLO: 'Utente RDA',
        BUTTON: [{
            TIPO: ['A', 'C', 'D'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioFSE', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/pianificazione/inserisci', DISPLAY_VALUE: 'Pianificazione'},
                {LINK: '/profiliorariFSE', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/castelletto', DISPLAY_VALUE: 'Castelletto', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {LINK: '/validazionecorso', DISPLAY_VALUE: 'Validazione'},
                {LINK: '/monitoraggioValidazione', DISPLAY_VALUE: 'Monitoraggio Validazione'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }, {
            TIPO: ['B'],
            CAMPI: [
                {LINK: '/presenze', DISPLAY_VALUE: 'Presenze', SEARCH: {tab: TABS_CHOOSEN.ALLIEVI}},
                {
                    LINK: '/registro',
                    DISPLAY_VALUE: 'Registro Mese',
                    SEARCH: {tab: TABS_CHOOSEN.ALLIEVI, data: dayJS().format('YYYY-MM'), page: 1}
                },
                {LINK: '/calendarioSCR', DISPLAY_VALUE: 'Calendario'},
                {LINK: '/profiliorariSCR', DISPLAY_VALUE: 'Profili Orari'},
                {LINK: '/schedaCorso', DISPLAY_VALUE: 'Scheda'}
            ]
        }
        ],
        HEADER: [
            {LINK: '', DISPLAY_VALUE: 'Home'},
            {LINK: '/corsi', DISPLAY_VALUE: 'Corsi'}
        ],
        TABS: {
            PRESENZE : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            REGISTRO : {
                A: ['allievi', 'docenti'],
                B: ['allievi', 'tutor'],
                C: ['allievi', 'docenti'],
                D: ['allievi', 'docenti']
            },
            CASTELLETTO : {
                A: ['allievi', 'docenti', 'corso'],
                B: ['allievi', 'tutor', 'corso'],
                C: ['allievi', 'docenti','corso'],
                D: ['allievi', 'docenti','corso']
            }
        },
        EXTEND_COUSES_SEARCH: true,
        ACTION_DETTAGLIO: false,
        ACTION_VALIDA_DETTAGLIO: true,
        ACTION_MULTIPLE_SELECTED_REGISTRY: false,
        ACTION_MULTIPLE_DEVALIDATION_REGISTRY: true,
        STAMPA_PDF: true,
        DELETE_TIMBRATURE_MANUALI: true,
        DELETE_GIUSTIFICATIVI: true,
        DELETE_TIMBRATURE_AUTOMATICHE: true
    }
});

export const AUTOMATIC_MARKING_AVAILABLE_ROLES = Object.freeze([
    'SYSTEMADMIN',
    'ADMIN',
    'DOCENTE',
    'ALLIEVO'
    //,    'RDA'
]);

export const PLANNING_IN_THE_PAST_AVAILABLE_ROLES = Object.freeze([
    'SYSTEMADMIN',
    'ADMIN',
    'UTENTEREGIONE',
    'RDA',
    'UTR'
]);

